export interface MultiSelectItem {
  value: number | string
  label: string
  selected?: boolean
  children?: MultiSelectItem[]
}

export enum ToastColorEnum {
  NONE = '',
  SUCCESS = 'success',
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
}

export enum ButtonState {
  LOADING,
  SUCCESSFUL,
  FAILED,
}

export enum ButtonColorVariant {
  GRAY = 'gray',
  PURPLE = 'purple',
  RED = 'red',
  GREEN = 'green',
}

export enum ComponentSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export enum IndentationSize {
  SMALL = 50,
  MEDIUM = 100,
  LARGE = 200,
  DISABLED = 0,
}

export type SancareTogglePositionLabel = 'left' | 'right'

export enum FindBarColor {
  BLACK = 'black',
  PURPLE = 'purple',
}

export type CompletionOption<T> = {
  title: string
  description: string
  key: string
  value: T
}

export function isCompletionOption<T>(obj): obj is CompletionOption<T> {
  return (
    typeof (obj) === 'object'
    && 'title' in obj
    && 'description' in obj
    && 'key' in obj
    && 'value' in obj
  )
}

export type Class = string | Record<string, boolean> | Class[]